import { BrandliveEvent } from '@/types/projects.types';
import { LanguagesAbbr } from '@/types/translation.types';

/*
  Notes:
  In order to use these methods you need to pull the entire workingProject into your component using the `getWorkingProject` selector.
  This creates unnecessary re-renders in your component whenever any value in redux for your project changes, even if it doesn't
  effect your component.
  Therefore, while these aren't technically deprecated, I'm marking them as so just so that VS Code warns you when you try using it.
  Please use `useAppSelector(selectWorkingProjectDefaultLanguage)` and remove the entire project selector from your component.
  This will result in greater efficiency over the app.
*/

/**
 * @deprecated
 * While technically NOT deprecated, I'm marking it as such so that it screams in VS Code (see notes above)
 * Use `selectWorkingProjectDefaultLanguage` if possible for efficiency and remove your entire workingProject selector from your component if possible.
 */
export const getDefaultLanguage = (project: Partial<BrandliveEvent> | null): LanguagesAbbr => {
  // return user-set default language, if unset use first language from the homepage, if unset use first language from the first session
  return (project?.settings?.i18n?.base ??
    project?.homepage?.languages?.[0] ??
    project?.sessionsPreviews?.[0]?.languages?.[0] ??
    'en') as LanguagesAbbr;
};

/**
 * @deprecated
 * While technically NOT deprecated, I'm marking it as such so that it screams in VS Code (see notes above)
 * Use `selectWorkingProjectDefaultLanguage` if possible for efficiency and remove your entire workingProject selector from your component if possible.
 */
export const workingProjectDefaultLanguage = (workingProject: BrandliveEvent): LanguagesAbbr => {
  if (workingProject.settings.i18n?.base) {
    return workingProject.settings.i18n.base as LanguagesAbbr;
  }

  if (workingProject.homepage?.languages) {
    return workingProject.homepage.languages[0] as LanguagesAbbr;
  }

  return workingProject.sessions[0].default_language as LanguagesAbbr;
};
